import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Drawer, Input } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/es/form';
import {
  useUpdateVehicleModelMutation,
  useGetVehicleModelQuery,
  GetVehicleModelQuery,
} from '../../../graphql/datamodel.gen';
import { getClient } from '../../../apollo';
import _ from 'lodash';

interface IProps {
  visible: boolean;
  onClose: () => any;
  modelId: string;
}

interface IForm extends FormComponentProps {
  onSubmit: (name: string) => Promise<any>;
  onClose: () => any;
  model: GetVehicleModelQuery['vehicleModel'];
}
interface IFormState {
  loading: boolean;
}

class UpdateModelForm extends React.Component<IForm, IFormState> {
  state = {
    loading: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values: { name: string }) => {
      if (!err) {
        try {
          this.setState({
            loading: true,
          });
          await this.props.onSubmit(values.name);
          this.setState({
            loading: false,
          });
          this.props.onClose();
        } finally {
          this.setState({
            loading: false,
          });
        }
      }
    });
  };

  render() {
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical">
        <Form.Item required={true} label={'Nombre del modelo'}>
          {this.props.form.getFieldDecorator('name', {
            initialValue: this.props.model.name,
            rules: [
              {
                required: true,
              },
            ],
          })(<Input placeholder={'Por ej: Clase A'} />)}
        </Form.Item>
        <Form.Item>
          <Button
            loading={this.state.loading}
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Guardar cambios
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const MyUpdateModelForm = Form.create<IForm>()(UpdateModelForm);

const VehicleUpdateModel: React.FC<IProps> = (props: IProps) => {
  const [updateVehicleModelMut] = useUpdateVehicleModelMutation({
    client: getClient(),
  });

  const vehicleModelQueryResult = useGetVehicleModelQuery({
    variables: {
      id: props.modelId,
    },
    fetchPolicy: 'network-only',
  });

  const updateVehicleModel = (name: string) => {
    return updateVehicleModelMut({
      variables: {
        name,
        id: props.modelId,
      },
    });
  };

  return (
    <Drawer
      maskClosable={true}
      closable={true}
      width={300}
      visible={props.visible}
      onClose={props.onClose}
      destroyOnClose={true}
    >
      {props.visible &&
        props.modelId &&
        vehicleModelQueryResult?.data?.vehicleModel && (
          <MyUpdateModelForm
            model={vehicleModelQueryResult?.data?.vehicleModel}
            onSubmit={updateVehicleModel}
            onClose={props.onClose}
          />
        )}
    </Drawer>
  );
};

export default VehicleUpdateModel;
